<script>
	import BlockNavigation from '@/components/BlockNavigation/BlockNavigation';
	import Header from '@/components/Header/Header';
	import Login from '@/components/Login/Login';
	import Notification from '@/components/Notification/Notification';
	import Layer from '@/components/Layer/Layer';
	import List from '@/components/List/List';
	import Simple from '@/components/Simple/Simple';
	import Slider from '@/components/Slider/Slider';
	import Teaser from '@/components/Teaser/Teaser';
	import Footer from '@/components/Footer/Footer';
	import { AdHandler } from '@/services/helper/adHandler';

	export default {
		name: 'Homepage',
		components: {
			'hp-teaser': Teaser,
			'hp-block-navigation': BlockNavigation,
			'hp-header': Header,
			'hp-login': Login,
			'hp-notification': Notification,
			'hp-slider': Slider,
			'hp-list': List,
			'hp-simple': Simple,
			'hp-layer': Layer,
			'hp-footer': Footer
		},
		data () {
			return {
				adHandler: '',
				urlParams: new URLSearchParams(window.location.search)
			};
		},
		mounted () {
			const _this = this;
			document.body.setAttribute('data-site', 'hp');
			this.$store.commit('setChannelsRendered', true);

      const setPageVisibleOnColCountChange = () => {
        this.$store.commit('setPageVisible', true);
        document.removeEventListener('colCountChanged', setPageVisibleOnColCountChange);
      };
      document.addEventListener('colCountChanged', setPageVisibleOnColCountChange);

			// closure for scope
			(() => {
				window.addEventListener('load', async (e) => {
					_this.adHandler = new AdHandler(_this);

					if (window.PageConfig.stage.includes('live') || (!window.PageConfig.stage.includes('live') && this.urlParams.get('ads') !== 'false')) {
						await _this.adHandler.getAdServiceScripts();
					} else {
						console.log('ads off');
					}
				});
			})();
		}
	};
</script>

<template src="./Homepage.html"></template>
